import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import OrderTransactionsSection from './OrderTransactionsSection';
import './SingleAssetHlPortfolio.css';
import './OrderTransactionsSection.css';

const API_BASE =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_URL) ||
  (process.env.REACT_APP_API_URL
    ? `${String(process.env.REACT_APP_API_URL).replace(/\/$/, '')}/api`
    : 'https://trading.omniscalping.com/api');

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('sessionToken')}`,
});

function mapOrders(rows) {
  return (rows || []).map((o) => ({
    ...o,
    signal_source: [o.action, o.order_type].filter(Boolean).join(' · ') || 'single-asset-hl',
    is_paper: !!o.is_paper,
  }));
}

export default function SingleAssetHlOrderTransactions({
  open,
  onClose,
  onStatusMessage,
  refreshKey = 0,
}) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API_BASE}/single-asset-hl/orders`, {
        headers: authHeaders(),
        params: { limit: 100 },
      });
      setOrders(mapOrders(data.orders || []));
    } catch (e) {
      onStatusMessage?.(e.response?.data?.error || e.message, true);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  }, [onStatusMessage]);

  useEffect(() => {
    if (!open) return;
    load();
  }, [open, load, refreshKey]);

  if (!open) return null;

  return (
    <div className="sahl-portfolio-overlay" role="presentation" onClick={onClose}>
      <div
        className="sahl-portfolio-dialog sahl-orders-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="sahl-orders-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header>
          <h2 id="sahl-orders-title">Order Transactions</h2>
          <button type="button" className="sahl-portfolio-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </header>
        {loading ? (
          <p className="sahl-portfolio-hint">Loading order history…</p>
        ) : (
          <OrderTransactionsSection
            orders={orders}
            title=""
            hint="Filled, submitted, and cancelled Single Asset HL orders for your account."
            visibleRows={12}
          />
        )}
        <footer className="sahl-orders-footer">
          <button type="button" className="secondary-btn" disabled={loading} onClick={load}>
            Refresh
          </button>
        </footer>
      </div>
    </div>
  );
}
